import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Loader from '../../../components/Common/Loader';
import { setIsSavedFilterAppliedFilters, setVisitFilterQuery } from '../../../store/visitFilterSlice';
import { addDays, format } from 'date-fns';
const VisitFilterContext = createContext();

export const useVisitFilters = () => useContext(VisitFilterContext);

export const VisitFilterProvider = ({ children }) => {
  const dispatch = useDispatch();
  const [isInitialized, setIsInitialized] = useState(false);
  const [reloadFilter, setReloadFilter] = useState(true);
  const [savedFilterId, setSavedFilterId] = useState(null);
  const [tempFilters, setTempFilters] = useState({});
  const [filters, setFilters] = useState({ date: [[format(new Date(), 'yyyy-MM-dd')]] });
  const init = async () => {
    // const tempFilter = (await JSON.parse(localStorage.getItem('tempVisitsFilter'))) || {};
    // if (tempFilter) {
    //   dispatch(setVisitFilterQuery(tempFilter));
    dispatch(setIsSavedFilterAppliedFilters());
    //   setFilters(tempFilter);
    setIsInitialized(true);
    // }
  };

  useEffect(() => {
    init();
  }, []);

  const updateFilter = useCallback((key, value) => {
    setFilters((prev) => {
      console.log('top');
      if (key == 'page') localStorage.setItem('aTPn', value);
      if ('page' in prev && key != 'page') {
        console.log('first');
        if (key == 'searchTerm' && (!value || value?.length <= 0)) return { ...prev, [key]: [value], page: [localStorage.getItem('aTPn')] };
        localStorage.setItem('aTPn', prev?.page?.[0]);
        return { ...prev, [key]: [value], page: ['1'] };
      } else {
        return { ...prev, [key]: [value] };
      }
    });
  }, []);

  const updateTempFilter = useCallback((list) => {
    setTempFilters((prev) => ({ ...prev, ...list }));
  }, []);

  const applyButtonFilter = useCallback(
    (key, value) => {
      setFilters((prev) => {
        if ('page' in prev && (prev?.page?.[0] > 1 || prev?.page?.[0] != '1')) {
          return { ...prev, ...tempFilters, page: ['1'] };
        } else {
          return { ...prev, ...tempFilters };
        }
      });
    },
    [tempFilters, filters]
  );

  const updateFilterByList = useCallback((list) => {
    setFilters((prev) => ({ ...prev, ...list }));
  }, []);

  const addFilterList = useCallback((list, id = null) => {
    if (id) {
      setSavedFilterId(id);
    }
    setFilters((prev) => list);
  }, []);

  const updateFilterByListTags = useCallback((list) => {
    setFilters((prev) => {
      if (prev?.excludeTags?.length > 0 || prev?.includeTags?.length > 0) {
        return { ...prev, ...list };
      }
      return prev;
    });
  }, []);

  const addFilter = useCallback((key, value) => {
    setFilters((prev) => {
      if ('page' in prev && (prev?.page?.[0] > 1 || prev?.page?.[0] != '1')) {
        return {
          ...prev,
          page: ['1'],
          [key]: prev[key]?.includes(value) ? prev[key].filter((f) => f !== value) : [...(prev[key] || []), value]
        };
      } else {
        return { ...prev, [key]: prev[key]?.includes(value) ? prev[key].filter((f) => f !== value) : [...(prev[key] || []), value] };
      }
    });
  }, []);

  const buildQuery = useCallback(() => {
    return Object.entries(filters)
      ?.map(([key, values]) => {
        // Filter out undefined values before encoding
        const filteredValues = values.filter(value => value !== undefined && value !== null);
        return `${encodeURIComponent(key)}=${filteredValues.map(value => encodeURIComponent(value)).join(',')}`;
      })
      .join('&');
  }, [filters]);

  useEffect(() => {
    const temp = { ...filters };
    if (temp && typeof temp === 'object') {
      delete temp['searchTerm'];
      delete temp['limit'];
      delete temp['endDate'];
      delete temp['startDate'];
    }
    localStorage.setItem('tempVisitsFilter', JSON.stringify(temp));
  }, [filters]);

  if (!isInitialized) {
    return <Loader />;
  }

  return (
    <VisitFilterContext.Provider
      value={{
        filters,
        savedFilterId,
        updateFilter,
        buildQuery,
        updateTempFilter,
        applyButtonFilter,
        addFilter,
        updateFilterByList,
        updateFilterByListTags,
        addFilterList,
        setReloadFilter,
        reloadFilter
      }}
    >
      {children}
    </VisitFilterContext.Provider>
  );
};

export const useQuoteFilter = () => {
  const {
    updateFilter,
    buildQuery,
    savedFilterId,
    updateFilterByListTags,
    filters,
    updateTempFilter,
    applyButtonFilter,
    addFilterList,
    addFilter,
    updateFilterByList,
    setReloadFilter,
    reloadFilter
  } = useVisitFilters();
  return {
    updateFilter,
    buildQuery,
    filters,
    savedFilterId,
    addFilter,
    addFilterList,
    updateFilterByListTags,
    updateFilterByList,
    updateTempFilter,
    applyButtonFilter,
    setReloadFilter,
    reloadFilter
  };
};
